export default __webpack_public_path__ + "static/media/ic-medium.ba3cfefc.svg";